<template>
	<div class="header-page">
    <div class="header-content" @touchmove.prevent>
        <div class="disflex" style="justify-content: space-between;">
          <a class="logo logo-w" href="/"><img src="static/images/logo.png" /></a>
<!--          <div class="account-top disflex crfff ac" @click="getMenu('purchaseChances')">-->
          <div class="account-top disflex crfff ac" >
            <div>
              <strong class="crfff"><img width="20" src="../../static/images/hd-i1.png">{{info.score}}</strong>
              <div>{{$t('Chances')}}</div>
            </div>
          </div>
        </div>
    </div>
	</div>
</template>

<script>
    import Dialog from '../components/dialog'
    export default {
        name: 'app-header',
        components:{
          Dialog
        },
        data () {
            return {
              info:{},
              isShow:false,
            }
        },
        created(){
         let token =  localStorage.getItem('token')
          if(token){
            this.getInfo()
          }
        },
		methods: {
      getMenu(url){
          this.isShowMenu = url
          let that = this
          setTimeout(function(){
            that.$router.push({path:url,query:{url:url}});
          },500);
      },
      getInfo (){
        let that =this;
        that.$parent.$parent.loadModal(true);
        that.$api.post('/api/user/info',null,r =>{
        	that.$parent.$parent.returnCode(r,function(){
            that.info = r.data
            localStorage.setItem('info',r.data.score)
            localStorage.setItem('int_url',r.data.invite_url)
            that.$parent.$parent.loadModal(false);
          });
        })
      }
		}
    }
</script>



// WEBPACK FOOTER //
// src/components/Header.vue